import { Link,useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import config from "../../config/config";
import Loader from "../../components/Loader/Loader";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";

const EditTax = ({ callback, props, index, VariationID, ItemID }) => {
  const [formValues, setFormValues] = useState({
    ID: 0,
    TaxGroup: "",
    TaxId1: 0,
    TaxName1: "",
    TaxPercent1: "",
    TaxId2: 0,
    TaxName2: "",
    TaxPercent2: "",
    Cumulative: false,
    TaxId3: 0,
    TaxName3: "",
    TaxPercent3: "",
    TaxId4: 0,
    TaxName4: "",
    TaxPercent4: "",
    TaxId5: 0,
    TaxName5: "",
    TaxPercent5: "",
  });
  const [callbackTax, setCallbackTax] = useState([]);

  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [showModal, setShowModal] = useState(false);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);
  const [loading, setLoading] = useState(false);
  const [taxDropdown, setTaxDropdown] = useState([]);
  const [localValues,setLocalValues] = useState({})

  const paramObject = useParams();

  const terms = [{ label: "None", value: 0 }];

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/taxclassdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const response = res.data.ResponseData;
        const mappedReceivingItems = response.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.GROUP_ID,
          };

          return mappedItem;
        });
        setTaxDropdown(mappedReceivingItems);
        return res;
      });



  }, []);



  const handleTaxDropdown = (event) => {
    console.log(event, "hellooooooooooo");
    // setTaxDropdownValue(event.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, taxDropdown:event?.value};
      setLocalValues(x);
      localStorage.setItem("EditTaxDraft", JSON.stringify(x));
    }
    setSelectedTaxGroup(event.value);
    setLoading(true);
    axios
      .get(
        `${config.generalBaseUrl}/generals/taxclassfindbyid?taxclassid=${event.value}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const response = res.data.ResponseData;
          const mappedReceivingItems = response.map((item) => {
            const mappedItem = {
              TaxName: item.Name,
              TaxPercent: parseInt(item.Percent),
              type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
              TaxItemID: ItemID,
              TaxVariationID: VariationID,
            };
            return mappedItem;
          });
          console.log("mappedReceivingItems", mappedReceivingItems);
          setCallbackTax(mappedReceivingItems);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          setLoading(false);
        } else {
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSubmit = (values) => {
    // console.log("valuessssss", formValues);
    let taxValues = [
      {
        TaxItemID: ItemID,
        TaxName: formValues.TaxName1 ? formValues.TaxName1 : "",
        TaxPercent: formValues.TaxPercent1 ? formValues.TaxPercent1 : "",
        TaxVariationID: VariationID,
        type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
      },
      {
        TaxItemID: ItemID,
        TaxName: formValues.TaxName2 ? formValues.TaxName2 : "",
        TaxPercent: formValues.TaxPercent2 ? formValues.TaxPercent2 : "",
        TaxVariationID: VariationID,
        type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
      },
      {
        TaxItemID: ItemID,
        TaxName: formValues.TaxName3 ? formValues.TaxName3 : "",
        TaxPercent: formValues.TaxPercent3 ? formValues.TaxPercent3 : "",
        TaxVariationID: VariationID,
        type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
      },
      {
        TaxItemID: ItemID,
        TaxName: formValues.TaxName4 ? formValues.TaxName4 : "",
        TaxPercent: formValues.TaxPercent4 ? formValues.TaxPercent4 : "",
        TaxVariationID: VariationID,
        type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
      },
      {
        TaxItemID: ItemID,
        TaxName: formValues.TaxName5 ? formValues.TaxName5 : "",
        TaxPercent: formValues.TaxPercent5 ? formValues.TaxPercent5 : "",
        TaxVariationID: VariationID,
        type: VariationID ? "itemTax" : ItemID ? "itemTax" : "globalTax",
      },
    ];

    const filteredFormData = taxValues.filter(
      (data) => data.TaxName !== undefined && data.TaxPercent !== undefined
    );

    let taxdata = taxValues.filter(function (Taxdata) {
      return Taxdata.TaxName != "";
    });

    if (taxdata.length !== 0) {
      callback(taxdata, index);
      console.log("taxData inside condition", taxdata);
    } else {
      callback(callbackTax, index);
      console.log("callbackTax inside condition", callbackTax);
    }
    console.log("taxdata::>", callbackTax);
  };

 
  const handleClose = () => {
    setShowModal(false);
    setFormValues([]);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: newValue,
    }));

    if (paramObject.id === undefined) {
      const x = { ...localValues, [name]:newValue};
      setLocalValues(x);
      localStorage.setItem("EditTaxDraft", JSON.stringify(x));
    }
  };

  //for Storing the Draft

  useEffect(()=>{
    const savedData = localStorage.getItem("EditTaxDraft") || "";
    if (savedData && paramObject.id == undefined) {
      const parsedData = JSON.parse(savedData);
      console.log(parsedData,"parsedData")
      setLocalValues(parsedData);
      setSelectedTaxGroup(parsedData?.taxDropdown)

      setFormValues(
        {
          ...formValues,
          ID: parsedData?.ID,
          TaxGroup: parsedData?.TaxGroup,
          TaxId1: parsedData?.TaxId1,
          TaxName1: parsedData?.TaxName1,
          TaxPercent1: parsedData?.TaxPercent1,
          TaxId2: parsedData?.TaxId2,
          TaxName2: parsedData?.TaxName2,
          TaxPercent2: parsedData?.TaxPercent2,
          Cumulative: parsedData?.Cumulative,
          TaxId3: parsedData?.TaxId3,
          TaxName3: parsedData?.TaxName3,
          TaxPercent3: parsedData?.TaxPercent3,
          TaxId4: parsedData?.TaxId4,
          TaxName4: parsedData?.TaxName4,
          TaxPercent4: parsedData?.TaxPercent4,
          TaxId5: parsedData?.TaxId5,
          TaxName5: parsedData?.TaxName5,
          TaxPercent5: parsedData?.TaxPercent5,
        }
      )
    }
  },[])

  return (
    <>
      <Loader loading={loading} />
      <div
        className="modal fade"
 
        id={VariationID != "" ? `EditModal-${VariationID}` : "EditModal"}
        tabIndex={-1}
        aria-labelledby={
          VariationID ? `EditModal-${VariationID}-label` : "upset"
        }
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <div className="title-model" id="exampleModalLabel">
                Edit Taxes
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-content">
              <div className="modal-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row">
                      <label className="col-form-label col-md-2 form-label">
                        Tax Group
                      </label>
                      <div className="col-md-9">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          onChange={(event) => handleTaxDropdown(event)}
                          options={taxDropdown}
                          placeholder="Select Taxes"
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                          value={taxDropdown.find((el)=>el?.value===selectedTaxGroup)}
                          id="TaxGroup"
                          name="TaxGroup"
                          className="custom-search-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div className="col-form-label text-center bold">OR</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label className="col-form-label col-md-1 form-label">
                        Tax 1
                      </label>
                      <div className="col-md-5">
                        <input type="hidden" name="TaxId1" />
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxName1"
                          name="TaxName1"
                          placeholder="Tax Name"
                          value={formValues?.TaxName1}
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxPercent1"
                          name="TaxPercent1"
                          placeholder="Tax Percent"
                          value={formValues?.TaxPercent1}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label className="col-form-label col-md-1 form-label">
                        Tax 2
                      </label>
                      <div className="col-md-5">
                        <input type="hidden" name="TaxId2" />
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxName2"
                          name="TaxName2"
                          placeholder="Tax Name"
                          value={formValues?.TaxName2}
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxPercent2"
                          name="TaxPercent2"
                          placeholder="Tax Percent"
                          value={formValues?.TaxPercent2}
                        />
                      </div>
                      <div className="col-md-3">
                        <input
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="Cumulative"
                          name="Cumulative"
                          onChange={(e) => handleChange(e)}
                          value={formValues?.Cumulative}
                        />
                        <span> Cumulative</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label className="col-form-label col-md-1 form-label">
                        Tax 3:
                      </label>
                      <div className="col-md-5">
                        <input type="hidden" name="TaxId3" />
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxName3"
                          name="TaxName3"
                          placeholder="Tax Name"
                          value={formValues?.TaxName3}
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxPercent3"
                          name="TaxPercent3"
                          placeholder="Tax Percent"
                          value={formValues?.TaxPercent3}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label className="col-form-label col-md-1 form-label">
                        Tax 4
                      </label>
                      <div className="col-md-5">
                        <input type="hidden" name="TaxId4" />
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxName4"
                          name="TaxName4"
                          placeholder="Tax Name"
                          value={formValues?.TaxName4}
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxPercent4"
                          name="TaxPercent4"
                          placeholder="Tax Percent"
                          value={formValues?.TaxPercent4}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label className="col-form-label col-md-1 form-label">
                        Tax 5
                      </label>
                      <div className="col-md-5">
                        <input type="hidden" name="TaxId5" />
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxName5"
                          name="TaxName5"
                          placeholder="Tax Name"
                          value={formValues?.TaxName5}
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          id="TaxPercent5"
                          name="TaxPercent5"
                          placeholder="Tax Percent"
                          value={formValues?.TaxPercent5}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="save pull-right">
                  <Link
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleClose}
                    className="btn btn-secondary btn-sm me-1 mt-2"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm mx-2 mt-2"
                    data-bs-dismiss="modal"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
                {/* </Form> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTax;
